import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import {
  reduxForm,
  Field,
  getFormValues,
  change,
  initialize,
  destroy,
} from "redux-form";
import {
  ButtonBrand,
  ButtonGrey,
  ButtonSpan,
  ButtonWhite,
} from "Components/Button";
import Location from "Components/Search/Location";
import Results from "Components/Search/Results";
import CountryLookup from "./CountryLookup";
import FlightChoices from "./FlightChoices";
import EditRadius from "./EditRadius";
import ResultsMeta from "./ResultsMeta";
import Map from "./Map";
import ExtraDetails from "./ExtraDetails";
import SortBy from "./SortBy";
import { search } from "./search";
import { FaAngleDown, FaAngleUp, FaEdit, FaUndoAlt } from "react-icons/fa";
import SaveSearchButton from "Components/SavedSearches/SaveButton";
import FindPerfectSpace from "Components/FindPerfectSpace";
import { Link as ScrollLink } from "react-scroll";
import LocationChoices from "./LocationChoices";
import NamedLocation from "./NamedLocation";
import queryString from "query-string";
import { isAgency, isAgencyApproved, isLoggedIn, isRolePlatformAdmin, token } from "../../modules/auth";
import { omit } from "lodash";
import debounce from "lodash/debounce";
import {
  getNamedLocationSubGroups,
  getNamedLocations,
} from "modules/named-locations";
import { GOOGLE_MAPS_API_KEY } from "../../constants";
import Loading from "../../Components/Loading";
import { checkVenueForPreferredProgramme } from "../../services/hotelGroupService/preferredProgrammesService";
import { checkVenuesForCommercialDeals } from "../../services/commercialDealService/commercialDeals";
import HotelGroup from "../../Components/Search/HotelGroup";
import AgencyFilters from "./AgencyFilters";
import { func, object } from "prop-types";
import { fetchAgencies, fetchCompanies } from "../../redux/actions";
import { hasCorporateAccess, isCompanyUser } from "../../modules/permissions";
const defaultState = {
  categories: [],
  results: [],
  insInProgramme: [],
  hasCommercialDeal: [],
  count: 0,
  loading: false,
  error: null,
  open: {
    agency: true,
    location: true,
    delegates: false,
    type: false,
    rooms: false,
  },
};

class AdvancedSearch extends React.Component {
  static propTypes = {
    destroy: func.isRequired,
    change: func.isRequired,
    values: object.isRequired,
  };

  state = {
    ...defaultState,
    uuid: null,
  };

  constructor(props) {
    super(props);
    this.axiosCancelSource = axios.CancelToken.source();
  }

  doSearch = (params = {}, requireCriteria = false) => {
    if(Object.keys(params).includes('sortBy')) {
      localStorage.setItem('savedResultsSort', params['sortBy']);
    }
    this.axiosCancelSource.cancel("New Search");
    this.axiosCancelSource = axios.CancelToken.source();
    this.props.search(
      this.props.history,
      this.stateSetter,
      params,
      this.axiosCancelSource.token,
      requireCriteria
    );
  };

  componentDidMount() {
    const { location, dispatch } = this.props;
    this.setState({ uuid: crypto.randomUUID() });
    if(localStorage.getItem('savedResultsSort')) {
      dispatch(change('advanced-search', 'sortBy', localStorage.getItem('savedResultsSort')))
    }

    if (!this.props.isLoggedIn) {
      this.props.history.push(
        `/login?return=${encodeURI(
          this.props.route_location.pathname
        )}&logInToProceed=1`
      );
    }

    axios
      .get(`${window.API}/venue-categories`)
      .then(r => {
        this.setState({
          categories: r.data.map(item => ({
            text: item.name,
            value: item.id,
          })),
        });
      })
      .catch(err => {});

    let parsed = queryString.parse(this.props.history.location.search);
    parsed = omit(parsed, [
      "named_location_type",
      "named_location_group",
      "named_location",
      "results",
      "closePanels"
    ]);
    if(parsed.location){
      dispatch(change('advanced-search', 'location',parsed.location))
      dispatch(change('advanced-search', 'lat',parsed.lat))
      dispatch(change('advanced-search', 'lng',parsed.lng))
      dispatch(change('advanced-search', 'location_type',parsed.location_type))
      dispatch(change('advanced-search', 'radius',parsed.radius))
      dispatch(change('advanced-search', 'capacity',parsed.capacity))
    }
    const { types, results, closePanels = false, ...params } = parsed;

    let typesAsString = Array.isArray(types)
      ? types
      : types === undefined
      ? []
      : [types];
    params.types = typesAsString.map(i => Number(i));
    if (Object.keys(params).length > 1) {
      this.props.initialize(params, {
        updateUnregisteredFields: true,
      });
    }
    // no saved form state (e.g. after logout) - preselect Map like the "Map" radio does
    dispatch((d, getState) => {
      const v = getFormValues("advanced-search")(getState()) || {};
      if (!v.location_type) {
        d(change('advanced-search', 'location_type', this.props.initialValues.location_type))
        if (!v.radius) {
          d(change('advanced-search', 'radius', this.props.initialValues.radius))
        }
      }
    })
    let sortBy = null
    if (this.props.isAgency || this.props.isRolePlatformAdmin) {
      this.props.fetchAgencies(this.props.token, 1, { visibleOnly: true }, true).then(response => {
        this.setState({
          agencies: response.data.data
        })
        if(parsed.agency) {
          let agency = response.data.data.find(function (agency) {
            return parseInt(agency.id) === parseInt(parsed.agency)
          })
          let company = null;
          if(parsed.company) {
            company = agency.companies.find(function (company) {
              return parseInt(company.id) === parseInt(parsed.company)
            })
          }
          this.setState({
            companies: agency.companies,
            selectedAgency: parsed.agency,
            selectedAgencyAsObj: {
              text: agency.name,
              value: agency.id,
              label: agency.name,
            },
            selectedCompany: company ? parsed.company : null,
            selectedCompanyAsObj: company ? {
              text: company.name,
              value: company.id,
              label: company.name,
              isCorporate: company.isCorporate
            } : null
          })
          dispatch(change('advanced-search', 'agency',  parsed.agency))
          if(company && company.isCorporate) {
            sortBy = "Company Preferred Programme"
            dispatch(change('simple-search', 'sortBy', sortBy))
          }
          if(parsed.agency && (!parsed.company || !company || !company.isCorporate) ) {
            sortBy = "Agency Preferred Programme"
            dispatch(change('simple-search', 'sortBy', sortBy))
          }
        }
        if(response.data.data.length === 1){
          let agency = response.data.data.find(x=>x!==undefined)
          this.setState({
            companies:  agency.companies,
            selectedAgency: agency.id
          })
          if(parsed.company){
            let company = agency.companies.find(function (company) {
              return parseInt(company.id) === parseInt(parsed.company)
            })
            if(company) {
              this.setState({
                selectedCompany: company ? parsed.company : null,
                selectedCompanyAsObj: company ? {
                  text: company.name,
                  value: company.id,
                  label: company.name,
                  isCorporate: company.isCorporate
                } : null
              })
              if(company.isCorporate) {
                sortBy = "Company Preferred Programme"
                dispatch(change('simple-search', 'sortBy', "Company Preferred Programme"))
              }else{
                sortBy = "Agency Preferred Programme"
                dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
              }
            }

            if(parsed.agency && (!parsed.company || !company || !company.isCorporate) ) {
              sortBy = "Agency Preferred Programme"
              dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
            }
          }else{
            sortBy = "Agency Preferred Programme"
            dispatch(change('simple-search', 'sortBy', "Agency Preferred Programme"))
          }
          dispatch(change('advanced-search', 'agency',  agency.id))
        }
      });
    }

    if(parsed.company) {
      this.setState({
        selectedCompany: parsed.company
      })
      dispatch(change('advanced-search', 'company',  parsed.company))
    }
    if(this.props.isCompanyUser && this.props.isCorporate) {
      parsed.sortBy = "Company Preferred Programme"
      dispatch(change('simple-search', 'sortBy', "Company Preferred Programme"))
    }
    if(this.props.isCompanyUser && !this.props.isCorporate) {
      this.doSearch(parsed, true);
      this.setState({
        searchTerm: this.props.location,
      });
      if (closePanels === "true") {
        this.toggleAllParams(false, false);
      }
      return;
    }
    checkVenueForPreferredProgramme(this.props.token, parsed.agency,  parsed.company).then(response => {
      this.setState({
        isInProgramme: response,
      });
      this.doSearch(parsed, true);
      this.setState({
        searchTerm: this.props.location,
      });
      if (closePanels === "true") {
        this.toggleAllParams(false, false);
      }
    });



  }

  reset = () => {
    this.props.initialize(this.props.initialValues, {
      updateUnregisteredFields: true,
    });

    this.setState({
      ...defaultState,
      categories: this.state.categories,
    });
  };

  stateSetter = {
    loading: () => this.setState({ loading: true, results: [] }),
    error: () => this.setState({ loading: false, error: true }),
    clear: () =>
      this.setState({ ...defaultState, categories: this.state.categories }),
    results: (results, count, prefProgramme,  v) => {
      checkVenuesForCommercialDeals(results.map(r => r.id), this.props.token).then(response => {
        this.setState({
          hasCommercialDeal: response,
        });
      });
      if (prefProgramme && this.state.isInProgramme) {
        let isInProgramme = this.state.isInProgramme;
        let orderedResults = results;
        if(this.state.selectedCompany) {
          orderedResults = results.sort(function(a, b) {
            return (
              (
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === b.id
                  ) !== "undefined")) -
              (
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === a.id
                  ) !== "undefined"))
            );
          });
        }else{
          orderedResults = results.sort(function(a, b) {
            return (
              ((isInProgramme &&
                  isInProgramme.agency &&
                  typeof isInProgramme.agency.find(company => company === b.id) !==
                  "undefined") ||
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === b.id
                  ) !== "undefined")) -
              ((isInProgramme &&
                  isInProgramme.agency &&
                  typeof isInProgramme.agency.find(company => company === a.id) !==
                  "undefined") ||
                (isInProgramme.company &&
                  typeof isInProgramme.company.find(
                    company => company === a.id
                  ) !== "undefined"))
            );
          });
        }
        this.setState({
          results: orderedResults,
          count,
          loading: false,
          error: false,
        });
      } else {
        if(typeof v.sortBy !== "undefined") {
          let ordered = this.sortForPP(results, this.state.isInProgramme, v.sortBy);
          this.setState({
            results: ordered,
            count,
            loading: false,
            error: false,
          });
        }else{
          this.setState({
            results,
            count,
            loading: false,
            error: false,
          });
        }

      }
    },
    tab: (name, state) => {
      const tabs = this.state.open;
      tabs[name] = state;
      this.setState({ open: { ...tabs } });
    },
  };

  toggleAllParams = (event, override = undefined) => {
    const areClosed =
      override !== undefined
        ? override
        : Object.values(this.state.open).includes(false);
    this.setState({
      open: {
        location: areClosed,
        delegates: areClosed,
        type: areClosed,
        rooms: areClosed,
      },
    });
  };

  openAllWithDelay = () => {
    const areClosed = Object.values(this.state.open).includes(false);
    if (areClosed) {
      setTimeout(() => {
        this.setState({
          open: {
            location: true,
            delegates: true,
            type: true,
            rooms: true,
          },
        });
      }, 500);
    }
  };

  submit = () => {
    // nowt
  };

  resultsHasDestinations = () => {
    const { results } = this.state;
    return !!results && results.some(result => result.destination_city);
  };

  sectionHeader = (name, key) => (
    <ButtonSpan
      onClick={() => {
        this.setState({
          open: {
            ...this.state.open,
            [key]: !this.state.open[key],
          },
        });
      }}
      className="outline-none"
      id={key}
    >
      <h2
        className={`text-3xl flex justify-between bg-grey p-3 leading-none border-l-2 font-semibold border-black relative${
          this.state.open[key] ? "" : " border-b"
        }`}
      >
        {name}
        <i className={`fal fa-${this.state.open[key] ? "minus" : "plus"}`} />
      </h2>
    </ButtonSpan>
  );

  getAgencyOptions = () => {
    if(this.state.agencies) {
      return this.state.agencies.map(function (agency) {
        return {
          text: agency.name,
          value: agency.id,
          label: agency.name,
        }
      })
    }else {
      return []
    }
  }

  getCompanyOptions = () => {
    if(this.state.companies) {

      return this.state.companies.map(function (company) {
        return {
          text: company.name,
          value: company.id,
          label: company.name,
          isCorporate: company.isCorporate
        }
      })
    }else {
      return []
    }
  }

  agencyOnChange = (e) => {
    const { location, dispatch } = this.props;
    let agency = this.state.agencies.find(function (agency) {
      return parseInt(agency.id) === parseInt(e.value)
    })
    this.setState({
      selectedAgency: e.value,
      companies: agency.companies,
      selectedAgencyAsObj: e,
      selectedCompany: null,
      selectedCompanyAsObj: null
    })
    dispatch(change('advanced-search', 'sortBy', "Agency Preferred Programme"))
    dispatch(change('advanced-search', 'agency',  e.value))
    localStorage.setItem('savedResultsSort',  "Agency Preferred Programme");
    checkVenueForPreferredProgramme(this.props.token, e.value,null).then(response => {
      let orderedResults = this.sortForPP(this.state.results, this.state.isInProgramme, "Agency Preferred Programme")
      this.setState({
        isInProgramme: response,
        results: orderedResults,
      });
    });

  }

  companyOnChange = debounce((e, v, pv, name) => {
    const { location, dispatch } = this.props;
    let company = this.state.companies.find((company) => parseInt(company.id) === parseInt(e.value));
    if(company && company.isCorporate){
      this.setState({
        selectedCompany: e.value,
        selectedCompanyAsObj: e,
        loading:true,
        results: []
      })
      dispatch(change('advanced-search', 'sortBy',   "Company Preferred Programme"))
      dispatch(change('advanced-search', 'company',  e.value))
      localStorage.setItem('savedResultsSort', "Company Preferred Programme");
      checkVenueForPreferredProgramme(this.props.token, this.state.selectedAgency, e.value).then(response => {
        this.setState({
          isInProgramme: response,
        });

        this.props.search(this.props.history, this.stateSetter, {
          sortBy: this.props.values.sortBy,
          commission: name === "agencyRates" ? v : 0,
          [name]:
            name === "venueCategoryId" && v !== null
              ? v.map(option => option.value)
              : v,
        });
      });
    }else{
      this.setState({
        selectedCompany: e.value,
        selectedCompanyAsObj: e
      })
      dispatch(change('advanced-search', 'company',  e.value))
      dispatch(change('advanced-search', 'sortBy', "Agency Preferred Programme"))
      localStorage.setItem('savedResultsSort',  "Agency Preferred Programme");
      checkVenueForPreferredProgramme(this.props.token, this.state.selectedAgency, e.value).then(response => {
        let orderedResults = this.sortForPP(this.state.results, this.state.isInProgramme, "Agency Preferred Programme")
        this.setState({
          isInProgramme: response,
          results: orderedResults,
        });
        this.props.search(this.props.history, this.stateSetter, {
          sortBy: this.props.values.sortBy,
          commission: name === "agencyRates" ? v : 0,
          [name]:
            name === "venueCategoryId" && v !== null
              ? v.map(option => option.value)
              : v,
        });
      });
    }



  })

  sortForPP = (results, isInProgramme, v = false) => {

    let sortBy = v || this.props.values.sortBy;
    let agencyResults = [];
    let companyResults = [];
    let nonResults = [];
    results.map(function(a) {
      let isInProgrammeCompanyA = isInProgramme &&
        isInProgramme.company &&
        typeof isInProgramme.company.find(company => company === a.id) !==
        "undefined";

      let isInProgrammeAgencyA = isInProgramme &&
        isInProgramme.agency &&
        typeof isInProgramme.agency.find(company => company === a.id) !==
        "undefined";

      if(sortBy === 'Agency Preferred Programme') {
        if(isInProgrammeAgencyA || (isInProgrammeAgencyA &&  isInProgrammeCompanyA) ) {
          agencyResults.push(a);
        }
        if(!isInProgrammeAgencyA &&  isInProgrammeCompanyA ) {
          companyResults.push(a);
        }
        if(!isInProgrammeAgencyA && !isInProgrammeCompanyA) {
          nonResults.push(a)
        }
      }
      if(sortBy === 'Company Preferred Programme') {
        if(isInProgrammeCompanyA || (isInProgrammeAgencyA &&  isInProgrammeCompanyA) ) {
          companyResults.push(a);
        }
        if(isInProgrammeAgencyA &&  !isInProgrammeCompanyA ) {
          agencyResults.push(a);
        }
        if(!isInProgrammeAgencyA && !isInProgrammeCompanyA) {
          nonResults.push(a)
        }
      }

    });
    let orderedResults = [];
    if(sortBy === 'Agency Preferred Programme') {
      orderedResults = orderedResults.concat(agencyResults);
      orderedResults = orderedResults.concat(companyResults);
      orderedResults = orderedResults.concat(nonResults)
    }else if(sortBy === 'Company Preferred Programme'){
      orderedResults = orderedResults.concat(companyResults);
      orderedResults = orderedResults.concat(agencyResults);
      orderedResults = orderedResults.concat(nonResults)
    }else{
      orderedResults = results;
    }

    return orderedResults
  }

  render() {
    //    console.log({ named_location: this.props.named_location });
    return (
      <>
        <div className="bg-light-grey">
          <div className="container mx-auto px-3 bg-white">
            <div className="-mx-3 flex flex-wrap">
              <form
                noValidate
                onSubmit={this.props.handleSubmit(this.submit)}
                className="w-full xl:w-3/4 xxl:w-5/6 p-3"
              >
                <p className="mb-5 border-b border-black pb-1 hidden">
                  Skip the advanced search,{" "}
                  <Link to="/request-for-proposal" className="font-normal">
                    upload your brief
                  </Link>{" "}
                  and speak to a venue expert.
                </p>
                <div className="flex items-center justify-between">
                  <h1 className="mt-2 mb-5 text-4xl md:text-5xl">
                    Advanced{" "}
                    <span className="hidden sm:inline-block">Venue </span>{" "}
                    Search
                  </h1>
                  <div className="flex pointer" onClick={this.toggleAllParams}>
                    {Object.values(this.state.open).includes(false) ? (
                      <>
                        <span className="uppercase font-heading font-bold text-sm mr-4">
                          Expand all
                        </span>
                        <FaAngleDown />
                      </>
                    ) : (
                      <>
                        <span className="uppercase font-heading font-bold text-sm mr-4">
                          Collapse all
                        </span>
                        <FaAngleUp />
                      </>
                    )}
                  </div>
                </div>
                <AgencyFilters
                  open={this.state.open}
                  sectionHeader={this.sectionHeader}
                  getAgencyOptions={this.getAgencyOptions}
                  agencyOnChange={this.agencyOnChange}
                  companyOnChange={this.companyOnChange}
                  getCompanyOptions={this.getCompanyOptions}
                  isSuperAgencyAndHasMultipleAgencies={this.props.isSuperAgencyAndHasMultipleAgencies}
                  isAgency={this.props.isAgency}
                  isRolePlatformAdmin={this.props.isRolePlatformAdmin}
                  selectedAgency={this.state.selectedAgency}
                  selectedCompany={this.state.selectedCompany}
                  selectedCompanyAsObj={this.state.selectedCompanyAsObj}
                  selectedAgencyAsObj={this.state.selectedAgencyAsObj}
                  stateSetter={this.stateSetter}
                  searchTerm={this.props.searchTerm}
                  doSearch={this.doSearch}
                  history={this.props.history}
                />
                <div className="bg-off-white">
                  {this.sectionHeader("Choose your location", "location")}
                  <div
                    className={`${
                      this.state.open.location ? "flex flex-wrap" : "hidden"
                    }`}
                  >
                    <div className="col-w-full lg:col-w-1/2 px-0">
                      <div className="h-full flex flex-col justify-between">
                        <div className="bg-off-white mb-4">
                          <div className="col-w-full pt-12 px-3">
                            <LocationChoices reset={this.reset} />
                          </div>
                        </div>
                        {this.props.location_type === "Map" ? (
                          <>
                            <div className="px-3 pt-4 flex">
                              <Location
                                id="location-search"
                                formId="advanced-search"
                                icon="/img/map-marker.svg"
                                label="Choose a Destination"
                                placeholder="Enter a destination"
                                name="location"
                                size="lg"
                                onPlaceFound={(lat, lng, name) => {
                                  this.setState({
                                    searchTerm: name,
                                  });
                                  this.doSearch();
                                }}
                              />
                              {!this.props.isNamedLocationPostcodeSearch && (
                                <EditRadius
                                  search={params => this.doSearch(params)}
                                  stateSetter={this.stateSetter}
                                />
                              )}
                            </div>


                            <div className="px-3 pt-4 pb-20 h-96 relative">
                              <NamedLocation
                                search={params => this.doSearch(params)}
                                location={this.props.history.location}
                                searchTerm={this.state.searchTerm}
                              />
                              <div className="row px-2 py-4 w-full justify-between py-3 mt-10 absolute pin-b bg-light-grey mf">
                                <ScrollLink
                                  to={this.props.isAgency || this.props.isRolePlatformAdmin ? "agency" : "delegates"}
                                  smooth
                                  className="pointer"
                                >
                                  <ButtonBrand
                                    classes="mr-4 text-lg"
                                    onClick={() =>
                                      this.stateSetter.tab(this.props.isAgency || this.props.isRolePlatformAdmin ? "agency" : "delegates", true)
                                    }
                                  >
                                    Next
                                  </ButtonBrand>
                                </ScrollLink>
                                <ScrollLink
                                  smooth
                                  className="pointer"
                                  to="results"
                                >
                                  <ButtonWhite>See search results</ButtonWhite>
                                </ScrollLink>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="w-full lg:w-1/2">
                      {this.props.location_type === "Map" ? (
                        <Map
                          type="advanced"
                          results={this.state.results}
                          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                          loadingElement={<div style={{ height: `100%` }} />}
                          containerElement={
                            <div className="re-1/2 h-full relative" />
                          }
                          search={params => this.doSearch(params)}
                          mapElement={<div className="absolute pin" />}
                        />
                      ) : null}
                      {this.props.location_type === "Country" ? (
                        <div className="p-3 lg:pt-12">
                          <CountryLookup
                            search={params => this.doSearch(params)}
                          />
                        </div>
                      ) : null}
                      {this.props.location_type ===
                      "Flight time from the UK" ? (
                        <div className="p-3 lg:pt-12">
                          <FlightChoices
                            search={params => this.doSearch(params)}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <ExtraDetails
                    hasAgencyTab={this.props.isAgency || this.props.isRolePlatformAdmin}
                    sectionHeader={this.sectionHeader}
                    open={this.state.open}
                    count={this.state.count}
                    categories={this.state.categories}
                    stateSetter={this.stateSetter}
                    search={params => this.doSearch(params)}
                  />
                </div>
                <div className="mt-5 row" id="results">
                  {!this.state.loading && (
                    <>
                      <div className="col col-w-full lg:col-w-1/6 flex items-end">
                        <SortBy
                          stateSetter={this.stateSetter}
                          hasDestinations={this.resultsHasDestinations()}
                          search={params => this.doSearch(params)}
                          results={this.state.results}
                          isInProgramme={this.state.isInProgramme}
                          selectedCompanyAsObj={this.state.selectedCompanyAsObj}
                          saveSortBy={() => {
                            const { location, dispatch } = this.props;
                            localStorage.setItem('savedResultsSort', "Preferred Programme")
                              dispatch(change('advanced-search', 'sortBy', localStorage.getItem('savedResultsSort')))
                          }}
                          isCorporate={this.props.isCorporate}
                          isCompanyUser={this.props.isCompanyUser}
                        />
                      </div>
                      <div className="col mt-4 lg:mt-0 md:px-0 col-w-full lg:col-w-5/6 flex flex-row flex-wrap text-sm xxl:text-base items-end justify-end">
                        <ButtonGrey
                          classes="mb-2 lg:mb-0 w-full lg:w-auto md:px-4 mx-2"
                          onClick={() => {
                            this.reset();
                          }}
                        >
                          <FaUndoAlt className="mr-2" />
                          Start again
                        </ButtonGrey>
                        {this.props.isLoggedIn && (
                          <SaveSearchButton
                            searchForm={this.props.search}
                            results={this.state.results}
                            hideNameField={true}
                            classes="md:px-4 mx-2 w-full lg:w-auto mb-2 lg:mb-0 "
                          />
                        )}
                        <ScrollLink
                          to="location"
                          smooth
                          className="mx-2 w-full lg:w-auto mb-2 lg:mb-0 pointer"
                        >
                          <ButtonGrey
                            classes="md:px-4 w-full lg:w-auto items-center justify-center flex mb-2 lg:mb-0 "
                            onClick={this.openAllWithDelay}
                          >
                            <FaEdit className="mr-2" />
                            Edit search
                          </ButtonGrey>
                        </ScrollLink>
                      </div>
                    </>
                  )}
                </div>
                <div className="w-full mt-10">
                  {this.state.loading ? (
                    <Loading />
                  ) : (
                    <Results
                      type="advanced"
                      results={this.state.results}
                      loading={this.state.loading}
                      error={this.state.error}
                      uuid={this.state.uuid}
                      isInProgramme={this.state.isInProgramme}
                      onWhite
                      hasCommercialDeal={this.state.hasCommercialDeal}
                      selectedCompany={this.state.selectedCompany}
                    />
                  )}
                </div>
              </form>
              <div className="w-full xl:w-1/4 xxl:w-1/6 p-3">
                <ResultsMeta
                  count={this.state.count}
                  loading={this.state.loading}
                  error={this.state.error}
                  radius={this.props.radius}
                  reset={this.reset}
                  results={this.state.results}
                  selectedCompany={this.state.selectedCompany}
                  search={() => this.doSearch()}
                />
              </div>
            </div>
          </div>
        </div>
        <FindPerfectSpace />
      </>
    );
  }
}

export default withRouter(
  reduxForm({
    form: "advanced-search",
    destroyOnUnmount: false,
    enableReinitialize: true,
  })(
    connect(
      (state, props) => {
        const v = getFormValues("advanced-search")(state) || {};
        let hasLocation;
        switch (v.location_type) {
          case "Map":
            hasLocation = !!v.location;
            break;
          case "Country":
            hasLocation = !!v.country_id;
            break;
          case "Flight time from the UK":
            hasLocation = !!v.flight_time_from_uk;
            break;
          default:
            hasLocation = false;
        }
        const isNamedLocationSearch = !!v.named_location;
        let isNamedLocationPostcodeSearch = false;
        let namedLocations = [];
        let namedLocationSubGroups = [];
        if (isNamedLocationSearch) {
          namedLocationSubGroups = getNamedLocationSubGroups(state);
          namedLocations = getNamedLocations(state);
          const matchedLocation = namedLocations.find(
            loc => Number(loc.id) === Number(v.named_location)
          );
          //                console.log({ matchedLocation });
          isNamedLocationPostcodeSearch =
            matchedLocation &&
            matchedLocation.postcode &&
            matchedLocation.postcode.length > 0;
        }
        let parsed = queryString.parse(props.history.location.search);
        return {
          location_type: v.location_type,
          location: v.location,
          route_location: props.location,
          country_id: v.country_id,
          flight_time_from_uk: v.flight_time_from_uk,
          hasLocation,
          isLoggedIn: isLoggedIn(state),
          namedLocationSubGroups,
          namedLocations,
          isNamedLocationSearch: isNamedLocationSearch,
          isNamedLocationPostcodeSearch: isNamedLocationPostcodeSearch,
          isRolePlatformAdmin: isRolePlatformAdmin(state),
          isAgency: isAgency(state),
          isAgencyApproved: isAgencyApproved(state),
          isSuperAgencyAndHasMultipleAgencies: state.auth.agency && state.auth?.agency?.is_super_agent  &&  state.auth.agency.child_agencies &&  state.auth.agency.child_agencies.length  > 0,
          token: token(state),
          isCompanyUser: isCompanyUser(state.auth),
          isCorporate: state.auth?.corporateAccount && hasCorporateAccess(state.auth),
          values:  v,
          initialValues: {
            location_type: "Map",
            back_projection: 0,
            exhibition: 0,
            radius: 1609.344 * 30,
            types: [1],
            types_text: ["Hotels"],
            sortBy: "ContentUpdate",
            agency: parsed.agency ? parsed.agency : null,
            company: parsed.company ? parsed.company : null,
            location: parsed.location  ? parsed.location : null,
            capacity: parsed.capacity ? parsed.capacity : null
          },
        };
      },
      { initialize,
        destroy,
        search,
        change,
        fetchAgencies,
        fetchCompanies
      }
    )(AdvancedSearch)
  )
);
